import React from "react";
import css from "./pricing.module.css";
import { NavLink } from "react-router-dom";

const Pricing = ({ data }) => {
  const { topColor, bgColor, priceColor, textColor, price, li1, li2, li3 } = data;
  return (
    <div className={css.price_tab} style={{ background: bgColor }}>
      <div
        className={css.price_top}
        style={{ borderBottom: "2px dotted grey" }}
      >
        <h4 style={{ color: topColor }}>Scater</h4>
        <h2 style={{ color: priceColor }}>
          ${price}<span style={{ color: textColor }}>/month</span>
        </h2>
      </div>
      <ul style={{ color: topColor }} className={css.price_list}>
        <li>
          <span style={{ color: textColor }}>{li1}</span>
        </li>
        <li>
          <span style={{ color: textColor }}>{li2}</span>
        </li>
        <li>
          <span style={{ color: textColor }}>Real-Time Feedback</span>
        </li>
        <li>
          <span style={{ color: textColor }}>Video Dedicated Support</span>
        </li>
        <li>
          <span style={{ color: textColor }}>{li3}</span>
        </li>
        <li>
          <span style={{ color: textColor }}> Team Collaboration Tools</span>
        </li>
        <li>
          <span style={{ color: textColor }}> Automated Updated Features</span>
        </li>
        <li>
          <span style={{ color: textColor }}> 24/7 Life time Support</span>
        </li>
      </ul>
      <div className={css.btn}>
        <NavLink>
          <button>Start For Free</button>
        </NavLink>
      </div>
    </div>
  );
};

export default Pricing;
